import { useEffect, useRef } from 'react';
import tooltipStyles from './tooltip.module.less';

export const Tooltip = ({ children, text, visibleOnMobile }) => {
    const tooltipContainerRef = useRef(null);
    const tooltipContentRef = useRef(null);

    const handleDropdownPosition = () => {
        const screenPadding = 16;
        const containerRect = tooltipContainerRef.current.getBoundingClientRect();
        const contentRect = tooltipContentRef.current.getBoundingClientRect();
        const contentRightX = contentRect.x + contentRect.width;
        const containerRightX = containerRect.x + containerRect.width;

        if (contentRect.x < 0) {
            tooltipContentRef.current.style.left = '0';
            tooltipContentRef.current.style.right = 'auto';
            tooltipContentRef.current.style.transform = `translateX(${-containerRect.x + screenPadding}px)`;
        } else if (contentRightX > window.innerWidth) {
            tooltipContentRef.current.style.left = 'auto';
            tooltipContentRef.current.style.right = '0';
            tooltipContentRef.current.style.transform = `translateX(${
                window.innerWidth - containerRightX - screenPadding
            }px)`;
        }
    };
    const handleClick = (e) => {
        tooltipContentRef.current.classList.toggle(tooltipStyles.active);
        handleDropdownPosition();
        e.stopPropagation();
    };

    const handleClickOutside = (event) => {
        if (tooltipContainerRef.current && !tooltipContainerRef.current.contains(event.target)) {
            tooltipContentRef.current.classList.remove(tooltipStyles.active);
        }
    };

    useEffect(() => {
        if (visibleOnMobile) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div
            className={tooltipStyles.tooltip}
            ref={tooltipContainerRef}
            onMouseEnter={handleDropdownPosition}
            onClick={visibleOnMobile ? (e) => handleClick(e) : undefined}
            aria-hidden
        >
            <div className={tooltipStyles.tooltipContent} ref={tooltipContentRef}>
                {text}
            </div>
            {children}
        </div>
    );
};
